import type {ElementType} from 'react';
import type {Components, Theme} from '@mui/material';
import {listItemTextClasses, SvgIcon} from '@mui/material';
import ArrowDownBoldIcon from '@/modules/shared/ui/kit/icons/ArrowDownBold';

const IconComponent: ElementType = (props) => (
  <SvgIcon
    component={ArrowDownBoldIcon}
    {...props}
  />
);

export const MuiSelect = (theme: Theme): Components['MuiSelect'] => ({
  defaultProps: {
    IconComponent,
    MenuProps: {
      disableRestoreFocus: false,
    },
  },
  styleOverrides: {
    select: {
      [`.${listItemTextClasses.root}`]: {
        marginTop: 0,
        marginBottom: 0,
      },
      [`.${listItemTextClasses.primary}`]: {
        fontSize: 'inherit',
        lineHeight: 'inherit',
      },
    },
    icon: {
      color: theme.palette.text2,
    },
  },
});
